
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_ghvqw_1g0cx_5"
};
  